<template>
  <Modal v-model="showModal" :mask-closable="false" width="500px">
    <div slot="header">编辑控制模式</div>
    <Form ref="form" :model="form" :rules="rules" :label-width="110">
      <FormItem prop="name" label="名称" style="margin-right: 15px">
        <div class="flex-row">
          <Input type="text" v-model="form.name" placeholder="名称"></Input>
        </div>
      </FormItem>
      <FormItem prop="connectType" label="亮度" style="margin-right: 15px">
        <Input type="number" number v-model="form.bright">
          <span slot="append">%</span>
        </Input>
      </FormItem>
      <FormItem prop="connectType" label="色温" style="margin-right: 15px">
        <Input type="number" number v-model="form.color">
          <span slot="append">%</span>
        </Input>
      </FormItem>
      <FormItem prop="connectType" label="控制时长" style="margin-right: 15px">
        <Input type="number" number v-model="form.expire">
          <span slot="append">分钟</span>
        </Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button style="margin-right: 8px" @click="cancel">取消</Button>
      <Button type="primary" :loading="loading" @click="ok">保存</Button>
    </div>
    <!-- <ModalSelectGroup v-model="showSelectModal" @newGroupSelected="newGroupSelected" /> -->
  </Modal>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'ModalAreaEdit',
  components:{
  },
  model: {
    prop: 'value',
    event: 'showChanged'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default(){ return {};}
    },
    stations: {
      type: Array,
      default(){ return [];}
    },
  },
  data () {
    return {
      showModal: this.value,
      // showSelectModal: false,
      loading: false,
      isAdd: false,
      types: [],
      groupName: '',
      mains: [],
      devices: [],
      form: {
        id: 0,
        name: '',
        bright: 100, //亮度
        color: 100, //色温
        expire: 100, //控制时长
      },
      rules: {
      },
    }
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
      if(newVal){
        // console.log('modal level edit mounted', this.item)
        this.isAdd = this.item.isAdd;
        if(!this.isAdd){
          this.form.id = this.item.data.id;
          this.form.name = this.item.data.name;
          this.form.bright = this.item.data.bright;
          this.form.color = this.item.data.color;
          this.form.expire = this.item.data.expire;
        }else{
          this.form.id = 0;
          this.form.name = '';
          this.form.bright = 100;
          this.form.color = 100;
          this.form.expire = 100;
        }
      }
    },
    showModal(val){
      this.$emit('showChanged', val);
    },
  },
  computed: {
    ...mapState('common', ['weeks', 'deviceTypes', 'productCodes', 'powerBoxTypes']),
  },
  mounted: function(){
  },
  methods: {
    ok: async function () {
      if(this.form.name.trim().length == 0){
        this.$Message.warning('请输入名称');
        return;
      }
      if(this.form.bright < 0 || this.form.bright > 100){
        this.$Message.warning('亮度必须在 0 - 100 之间');
        return;
      }
      if(this.form.color < 0 || this.form.color > 100){
        this.$Message.warning('色温必须在 0 - 100 之间');
        return;
      }
      if(this.form.expire <= 0 || this.form.expire > 65535){
        this.$Message.warning('控制时长必须在 1 - 65535 之间');
        return;
      }
      this.$axios.post(`//${this.domains.trans}/station/config/SaveScene`, this.form).then(res => {
        if(res.code != 0){
          // this.$Message.error(res.data);
        }else{
          this.$Message.info('保存成功');
          this.showModal = false;
          this.$emit('saved', {isAdd: this.isAdd, data: res.data});
        }
      })
    },
    cancel () {
      this.showModal = false;
      // this.$refs.form.resetFields();
    },
  }
}
</script>
<style scoped>
.form-item-group{
  border: solid 1px rgba(129, 124, 124, 0.377);
  border-radius: 12px;
  margin-bottom: 15px;
}
.group-header{
  /* border: solid 1px blue; */
  background-color: rgba(221, 216, 216, 0.808);
  margin-bottom: 15px;
  height: 35px;
  border-radius: 12px 12px 0 0;
  line-height: 35px;
  font-weight: bold;
  padding: 0 10px;
}
  .demo-drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }
  .form{
    height: calc(100% - 54px);
    overflow: auto;
  }
  .readonly{
    background: #eee
  }
</style>